import React from "react";
import { motion } from "motion/react";
import style from "./style.module.scss";

const title = "$Kawaii — A Reward for Your Effort";

const text = `
You've been active, consistent, and dedicated, spending your time and energy on this amazing platform.

$Kawaii is a reflection of that effort, turning your activity into something truly meaningful. Each $Kawaii you earn represents your contribution to the Kawaii Nyan world, a mark of how far you've come and how engaged you've been.

So, congratulations on your well-deserved reward! This is just the beginning of a new chapter with Kawaii Nyan, where every action counts and every meow moves you forward.
`;

const StoryView: React.FC = () => {
  const titleChars = title.split("");
  const textChars = text.split("");

  const renderAnimatedText = (chars: string[]) =>
    chars.map((char, index) =>
      char === "\n" ? (
        <br key={index} />
      ) : (
        <motion.span
          key={index}
          variants={{
            hidden: { opacity: 0, y: 6 },
            visible: {
              opacity: 1,
              y: 0,
              transition: { duration: 0.18, ease: "easeOut" },
            },
          }}
          style={{
            display: "inline",
            whiteSpace: "pre-wrap",
            overflowWrap: "anywhere",
          }}
        >
          {char}
        </motion.span>
      )
    );

  return (
    <div className={style.storyContainer}>
      <motion.div
        className={style.storyTitle}
        initial="hidden"
        animate="visible"
        variants={{
          hidden: { opacity: 1 },
          visible: { transition: { staggerChildren: 0.02 } },
        }}
      >
        {renderAnimatedText(titleChars)}
      </motion.div>

      <motion.div
        className={style.storyText}
        initial="hidden"
        animate="visible"
        variants={{
          hidden: { opacity: 1 },
          visible: { transition: { staggerChildren: 0.015 } },
        }}
      >
        {renderAnimatedText(textChars)}
      </motion.div>
    </div>
  );
};

export default StoryView;
